import React from 'react';
import { View } from 'react-native';
import RadioButton from './RadioButton';

//= ========================================================================

const RadioStrip = ({ chosenValue, valuesMap, onValueChanged }) => (
  <View style={{ flexDirection: 'row' }}>
    {Object.keys(valuesMap)
      .map((value) => (
        <RadioButton
          text={valuesMap[value]}
          isSelected={value === chosenValue}
          onPress={() => {
            onValueChanged(value);
          }}
        />
      ))}
  </View>
);
export default RadioStrip;
